import React from "react";
import { Container } from "reactstrap";
import Footer from "../../components/user/Footer";
import CardBlogs from "../../components/user/CardBlogs";

function Blogs() {
  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">
          Blogs
        </p>
      </div>

      <Container>
        <CardBlogs />
      </Container>

      <Footer />
    </div>
  );
}

export default Blogs;
